export const initialCarOtherFields = [
  {
    id: 'add-others',
    placeholderImage: 'car.jpg',
    title: 'Dodaj inne',
    required: false
  }
]